import * as Sentry from '@sentry/browser'
import loadImage from '../lib/loadImage'

export async function loadHandler(file: File): Promise<{ file: File, image?: HTMLImageElement}> {
  // console.log('loadHandler', file)
  // tslint:disable-next-line
  let image: undefined | HTMLImageElement = undefined
  try {
    image = await loadImage(window.URL.createObjectURL(file))
  } catch (error) {
    Sentry.captureException(error)
  }
  return { file, image }
}
